const initializedWrappers = new WeakSet();

function getCardMainImage(card) {
  return (
    card.querySelector(
      'slideshow-slide[aria-hidden="false"] .product-media__image'
    ) ||
    card.querySelector(
      'slideshow-slide:first-of-type .product-media__image'
    ) ||
    card.querySelector('.product-media__image') ||
    card.querySelector(
      '.product-card__content img:not(.sigla-card-swatch__image)'
    )
  );
}

function updateSwatchOverflow(wrapper) {
  if (!wrapper) return;

  const track = wrapper.querySelector('[data-sigla-swatches-track]');
  const nextButton = wrapper.querySelector('[data-sigla-swatches-next]');

  if (!track || !nextButton) return;

  const hasOverflow = track.scrollWidth > track.clientWidth + 3;

  wrapper.classList.toggle('is-overflowing', hasOverflow);
  nextButton.hidden = !hasOverflow;
}

function initializeSwatches(root = document) {
  const wrappers = root.querySelectorAll('[data-sigla-card-swatches]');

  wrappers.forEach((wrapper) => {
    updateSwatchOverflow(wrapper);

    if (initializedWrappers.has(wrapper)) return;

    initializedWrappers.add(wrapper);

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        updateSwatchOverflow(wrapper);
      });

      resizeObserver.observe(wrapper);
    }
  });
}

function selectCardVariant(button) {
  const card = button.closest('product-card');
  const wrapper = button.closest('[data-sigla-card-swatches]');

  if (!card || !wrapper) return;

  const variantId = button.dataset.variantId;
  const variantUrl = button.dataset.variantUrl;
  const variantImage = button.dataset.variantImage;

  const mainImage = getCardMainImage(card);
  const mainLink = card.querySelector('[ref="productCardLink"]');
  const actionLink = card.querySelector('[data-sigla-card-action-link]');

  if (mainImage && variantImage) {
    mainImage.src = variantImage;
    mainImage.srcset = variantImage;

    const picture = mainImage.closest('picture');

    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        source.srcset = variantImage;
      });
    }
  }

  if (mainLink && variantUrl) {
    mainLink.href = variantUrl;
  }

  if (actionLink && variantUrl) {
    actionLink.href = variantUrl;
  }

  if (variantImage) {
    card.dataset.featuredMediaUrl = variantImage;
  }

  if (variantId) {
    card.dataset.selectedVariantId = variantId;

    card.querySelectorAll('input[name="id"]').forEach((input) => {
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  wrapper.querySelectorAll('[data-sigla-card-swatch]').forEach((swatch) => {
    const isSelected = swatch === button;

    swatch.classList.toggle('is-active', isSelected);
    swatch.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
  });
}

function scrollSwatches(nextButton) {
  const wrapper = nextButton.closest('[data-sigla-card-swatches]');
  const track = wrapper?.querySelector('[data-sigla-swatches-track]');
  const firstSwatch = track?.querySelector('[data-sigla-card-swatch]');

  if (!track) return;

  const styles = getComputedStyle(track);
  const gap = Number.parseFloat(styles.columnGap || styles.gap || '8');
  const scrollAmount = firstSwatch
    ? firstSwatch.getBoundingClientRect().width + gap
    : 62;

  const isAtEnd =
    track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;

  if (isAtEnd) {
    track.scrollTo({
      left: 0,
      behavior: 'smooth',
    });
  } else {
    track.scrollBy({
      left: scrollAmount,
      behavior: 'smooth',
    });
  }
}

document.addEventListener('mouseover', (event) => {
  const button = event.target.closest('[data-sigla-card-swatch]');

  if (!button) return;

  if (button.contains(event.relatedTarget)) return;

  selectCardVariant(button);
});

document.addEventListener('click', (event) => {
  const nextButton = event.target.closest('[data-sigla-swatches-next]');

  if (nextButton) {
    event.preventDefault();
    event.stopPropagation();
    scrollSwatches(nextButton);
    return;
  }

  const swatchButton = event.target.closest('[data-sigla-card-swatch]');

  if (!swatchButton) return;

  event.preventDefault();
  event.stopPropagation();

  selectCardVariant(swatchButton);
});

document.addEventListener('shopify:section:load', (event) => {
  initializeSwatches(event.target);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeSwatches();
  });
} else {
  initializeSwatches();
}

/*
 * Product grids may append more cards during infinite scrolling.
 * This initializes overflow arrows for newly inserted cards.
 */
let initializationScheduled = false;

const mutationObserver = new MutationObserver(() => {
  if (initializationScheduled) return;

  initializationScheduled = true;

  requestAnimationFrame(() => {
    initializationScheduled = false;
    initializeSwatches();
  });
});

mutationObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});